import Spinner, { SpinnerSize } from '../spinner/spinner';
import styles from './table.module.scss';

export default function TableSpinner(): JSX.Element {
  return (
    <div className={styles.table_spinner}>
      <Spinner size={SpinnerSize.LARGE} />
    </div>
  );
}
